<template lang="pug">
.notifyStats
    v-card(light, flat)
        v-container
            v-row
                v-spacer
                v-col
                    v-row
                        v-col.d-flex
                            v-btn(:color="activeButton === 'lastMonth' ? 'brand' : 'white'"
                                :class="{'active-btn': activeButton === 'lastMonth'}"
                                @click="setActive('lastMonth')") Last Month
                            v-btn.ml-4(:color="activeButton === 'currentMonth' ? 'brand' : 'white'"
                                :class="{'active-btn': activeButton === 'currentMonth'}"
                                @click="setActive('currentMonth')") Current Month
                            datepicker.ml-4(label='Start Date', v-model='startDate')
                            datepicker.ml-4(label='End Date', v-model='endDate')
                            v-btn.ml-4(:color="activeButton === 'dateRange' ? 'brand' : 'white'"
                                :class="{'active-btn': activeButton === 'dateRange'}"
                                :disabled="!hasBothDates"
                                @click="setActive('dateRange')") Date Range
    v-card(light, flat)
        v-container
            v-data-table(
                :headers="overviewheaders"
                :items="overviewData"
                sort-by="customer"
                light,
                fixed-header,
                disable-pagination,
                hide-default-footer,
                height='80vh'
            )
            v-overlay(v-if="loading", absolute)
                v-progress-circular(indeterminate size="128" color="brand")
                .h2 Loading data in Progress....
</template>

<script>
import datepicker from '../common/datepicker.vue';
import devopsnotifystats from '@/components/devops/notifyStats.vue';
export default {
    components: { datepicker

    },
    data () { return {
        startDate:null,
        endDate:null,
        hasBothDates:false,
        currentCustomer: null,
        displayedInfo: [],
        loading: false,
        activeButton: 'currentMonth',
        lastActiveButton: null,
        overviewheaders: [
            {text: 'Calls', value: 'twilioCalls'},
            {text: 'SMS', value: 'twilioSMS'},
            //TODO: uncomment below lines when sparkpost and firebase support is added
            //{text: 'SparkPost Email', value: 'sparkPostCount'},
            //{text: 'Firebase Push', value: 'fireBaseCount'}
        ],
    };

    },
    methods: {
        setActive (button) {
            this.activeButton = button;

        },
        checkBothDates (){
            if(this.startDate?.trim() && this.endDate?.trim()){
                this.hasBothDates = true;
            }else{
                this.hasBothDates = false;
            }
        },
        getTwilioUsage (data, type) {
            if(!Array.isArray(data)){
                return data;
            }
            const item = data.find(d => d.description === type);
            return item ? item.usage : 0;
        },
        async commandTrigger () {
            this.loading = true;
            const allData = await this.post('getNotifyStats', {customer: this.$store.state.customerId, activeButton: this.activeButton, endDate: this.endDate, startDate: this.startDate});
            const sameCustomerCheck = allData.customerData[0].id === this.$store.state.customerId;
            if(sameCustomerCheck){
                this.displayedInfo = [allData];
            }

            this.loading = false;
        }
    },
    mounted () {
    },
    watch:{
        activeButton (oldVal, newVal) {
            this.commandTrigger();
        },
        startDate (){
            this.checkBothDates();
        },
        endDate (){
            this.checkBothDates();
        },
        customerId: {
            handler (value) {
                if(value)
                    this.commandTrigger();
            },
            immediate: true
        }
    },
    computed: {

        overviewData () {
            return this.displayedInfo.map(entry => ({
                twilioCalls: this.getTwilioUsage(entry.twilioData, 'Outbound Voice Minutes'),
                twilioSMS: this.getTwilioUsage(entry.twilioData, 'Standard Outbound SMS'),
                sparkPostCount: entry.sparkPostData[0]?.CountDelivered || 0,
                fireBaseCount: entry.fireBaseData[0]?.CountDelivered || 0
            }));

        },
        customerId () {
            return this.$store.state.customerId;
        }
    }
};
</script>+

<style scoped>
.v-btn {
  color: 'brand';
  margin: 5px;
  transition: background-color 0.2s;
}

.active-btn {
  color: white  !important;
}

</style>
